import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a37c94af7111800146d1687_1782441363952_a3e850b0/nammaprice/src/app/not-found.tsx");
